export default "__VITE_ASSET__CCkvivve__"